<template>
  <div class="history-first-board">
    <div class="toolbar">
      <div class="toolbar-scroll">
        <el-date-picker
          v-model="tradeDate"
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          style="width: 150px"
        />
        <el-button type="primary" size="small" :loading="loading" @click="handleQuery">查询</el-button>
        <el-button size="small" :loading="nextDayLoading" :disabled="!tradeDate" @click="handleNextTradeDay">
          下一日
        </el-button>
        <el-button size="small" @click="openFilterConfig">过滤配置</el-button>
        <el-button size="small" @click="openRecordLibrary">记录库</el-button>
        <el-checkbox v-model="filterBaoVol">是否爆量</el-checkbox>
        <el-checkbox v-model="filterTouchBoard">爆量日摸板</el-checkbox>
        <el-checkbox v-model="filterSlope">分段斜率剔除 &gt; {{ slopeMinDisplay }}%</el-checkbox>
        <el-checkbox v-model="filterMarketCap70">过滤市值({{ marketCapMaxDisplay }}亿)</el-checkbox>
        <el-checkbox v-model="filterMa250">过滤MA250</el-checkbox>
        <el-checkbox v-model="filterAboveAllMa">过所有均线</el-checkbox>
        <el-checkbox v-model="filterDistToYearHigh">
          距年高 ≤ {{ distToYearHighMaxDisplay }}%
        </el-checkbox>
        <el-checkbox v-model="filterPreScreenScore">
          综合分 ≥ {{ preScreenScoreMinDisplay }}
        </el-checkbox>
        <span class="filter-chip-label">短期筹码</span>
        <el-select
          v-model="filterShortChipBands"
          multiple
          collapse-tags
          clearable
          size="small"
          placeholder="多选"
          class="filter-chip-band-select"
        >
          <el-option
            v-for="opt in shortChipOptions"
            :key="'short-' + opt.value"
            :label="opt.label"
            :value="opt.value"
          />
        </el-select>
        <span class="filter-chip-label">中期筹码</span>
        <el-select
          v-model="filterMidChipBands"
          multiple
          collapse-tags
          clearable
          size="small"
          placeholder="多选"
          class="filter-chip-band-select"
        >
          <el-option
            v-for="opt in midChipOptions"
            :key="'mid-' + opt.value"
            :label="opt.label"
            :value="opt.value"
          />
        </el-select>
        <span class="filter-chip-label">长期筹码</span>
        <el-select
          v-model="filterLongChipBands"
          multiple
          collapse-tags
          clearable
          size="small"
          placeholder="多选"
          class="filter-chip-band-select"
        >
          <el-option
            v-for="opt in longChipOptions"
            :key="'long-' + opt.value"
            :label="opt.label"
            :value="opt.value"
          />
        </el-select>
        <span v-if="rows.length" class="hint">
          共 {{ filteredRows.length }}{{ filteredRows.length !== rows.length ? ` / ${rows.length}` : '' }} 只
        </span>
      </div>
    </div>

    <div class="table-wrap">
      <el-table
        ref="hfbTable"
        v-loading="loading"
        :data="pagedRows"
        border
        size="small"
        height="100%"
        class="result-table"
        empty-text="请选择日期后查询"
      >
        <el-table-column label="记录库" width="72" align="center" fixed>
          <template slot-scope="{ row }">
            <el-checkbox
              :value="isInLibrary(row)"
              :disabled="!!row._libBusy"
              @change="(val) => onToggleLibrary(row, val)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="股票名称" min-width="88" fixed show-overflow-tooltip />
        <el-table-column prop="firstBoardDate" label="首板时间" min-width="100" />
        <el-table-column label="排名" min-width="200">
          <template slot-scope="{ row }">
            <span class="rank-tags">
              <el-tag v-if="row.rankT" size="mini" type="danger">T{{ row.rankT }}</el-tag>
              <el-tag v-if="row.rankB" size="mini" type="warning">B{{ row.rankB }}</el-tag>
              <el-tag v-if="row.rankJ2" size="mini" type="success">2J{{ row.rankJ2 }}</el-tag>
              <el-tag v-if="row.rankJ3" size="mini" type="info">3J{{ row.rankJ3 }}</el-tag>
              <span v-if="!row.rankT && !row.rankB && !row.rankJ2 && !row.rankJ3">-</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="freeFloatMarketCap" label="自由流通市值(亿)" min-width="150" sortable :formatter="fmtNum" />
        <el-table-column prop="ma250" label="MA250" min-width="100" sortable :formatter="fmtNum" />
        <el-table-column
          prop="distToYearHighPct"
          label="距年高涨幅"
          width="120"
          sortable
          :formatter="fmtDistYearHigh"
        />
        <el-table-column prop="finalBoards" label="连板高度" width="100" sortable />
        <el-table-column
          prop="preScreenScore"
          label="综合分"
          width="90"
          sortable
          :formatter="fmtPreScreenScore"
        />
        <el-table-column label="爆量" width="72" :formatter="fmtBaoVol" />
        <el-table-column
          prop="touchBoardNext"
          label="爆量日摸板"
          width="110"
          sortable
          :formatter="fmtBool"
        />
        <el-table-column prop="shortChip" label="短期筹码分" min-width="130" sortable :formatter="fmtChipPct" />
        <el-table-column prop="midChip" label="中期筹码分" min-width="130" sortable :formatter="fmtChipPct" />
        <el-table-column prop="longChip" label="长期筹码分" min-width="130" sortable :formatter="fmtChipPct" />
        <el-table-column prop="chipScoreSum" label="筹码总分" min-width="120" sortable :formatter="fmtChipPct" />
        <el-table-column prop="gapChipSum" label="补涨筹码分" min-width="130" sortable :formatter="fmtChipPct" />
        <el-table-column prop="fullChip" label="全周期筹码分" min-width="145" sortable :formatter="fmtChipPct" />
        <el-table-column prop="chipV2Score" label="筹码V2" min-width="100" sortable>
          <template slot-scope="{ row }">
            <span v-if="row.chipV2Score != null">{{ fmtChipV2Score(row) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="rangeAllD0" label="全周期粘合" min-width="120" sortable :formatter="fmtRangeAllD0" />
        <el-table-column prop="priceToMax" label="首板价格位置" min-width="130" sortable :formatter="fmtPriceToMax" />
        <el-table-column prop="pricePositionLabel" label="位置标签" min-width="130" sortable>
          <template slot-scope="{ row }">
            <span :class="{ 'chip-v2-overextended': row.pricePositionLevel === 'OVEREXTENDED' }">
              {{ row.pricePositionLabel || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="chipSlope" label="筹码分斜率" min-width="130" sortable :formatter="fmtSlope" />
        <el-table-column prop="mainNetInflow0" label="首板净流入(亿)" min-width="150" sortable :formatter="fmtYi" />
        <el-table-column prop="mainNetInflow1" label="次日净流入(亿)" min-width="150" sortable :formatter="fmtYi" />
        <el-table-column prop="mainNetInflow2" label="次次日净流入(亿)" min-width="160" sortable :formatter="fmtYi" />
        <el-table-column prop="netInflowToAmount0" label="首板净流入/成交额" min-width="175" sortable :formatter="fmtRatioPct" />
        <el-table-column prop="netInflowToAmount1" label="次日净流入/成交额" min-width="175" sortable :formatter="fmtRatioPct" />
        <el-table-column prop="netInflowToAmount2" label="次次日净流入/成交额" min-width="185" sortable :formatter="fmtRatioPct" />
        <el-table-column prop="auctionGain2b" label="2B竞价涨幅" min-width="130" sortable :formatter="fmtAuctionNum" />
        <el-table-column prop="auctionTurnover2b" label="2B竞价实际换手" min-width="155" sortable :formatter="fmtAuctionNum" />
        <el-table-column prop="auctionVolumeRatio2b" label="2B竞价量比" min-width="130" sortable :formatter="fmtAuctionNum" />
        <el-table-column prop="auctionKillScore2b" label="2B竞价绝杀分" min-width="145" sortable :formatter="fmtAuctionNum" />
        <el-table-column prop="auctionGain3b" label="3B竞价涨幅" min-width="130" sortable :formatter="fmtAuctionNum" />
        <el-table-column prop="auctionTurnover3b" label="3B竞价实际换手" min-width="155" sortable :formatter="fmtAuctionNum" />
        <el-table-column prop="auctionVolumeRatio3b" label="3B竞价量比" min-width="130" sortable :formatter="fmtAuctionNum" />
        <el-table-column prop="auctionKillScore3b" label="3B竞价绝杀分" min-width="145" sortable :formatter="fmtAuctionNum" />
      </el-table>
    </div>

    <div v-if="filteredRows.length" class="pager">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :total="filteredRows.length"
        :current-page.sync="page"
        :page-size.sync="pageSize"
        :page-sizes="[50, 100, 200, 500]"
      />
    </div>

    <el-dialog title="过滤配置" :visible.sync="filterConfigVisible" width="560px" append-to-body>
      <p class="tip">
        短 / 中 / 长各填三个分界值（百分数），生成「&lt;a、a~b、b~c」三档（默认 5 / 10 / 15），供对应下拉多选；空选表示不过滤。
      </p>
      <div v-for="item in rangeFields" :key="item.key" class="band-row">
        <span class="band-idx">{{ item.label }}</span>
        <el-input v-model="rangeDraft[item.key].a" placeholder="a" size="mini" style="width: 80px" />
        <span class="band-sep">/</span>
        <el-input v-model="rangeDraft[item.key].b" placeholder="b" size="mini" style="width: 80px" />
        <span class="band-sep">/</span>
        <el-input v-model="rangeDraft[item.key].c" placeholder="c" size="mini" style="width: 80px" />
        <span class="unit">%</span>
      </div>
      <p class="tip" style="margin-top: 16px">
        分段斜率（展示为原始值×1000%）：勾选后剔除斜率 &gt; 该阈值的票（默认 10，对应原始 0.01）。
      </p>
      <div class="band-row">
        <span class="band-idx">剔除&gt;</span>
        <el-input v-model="rangeDraft.slopeMin" placeholder="10" size="mini" style="width: 120px" />
        <span class="unit">%（×1000）</span>
      </div>
      <p class="tip" style="margin-top: 16px">
        距年高涨幅：勾选后保留「(年高-首板收盘)/首板收盘×100」≤ 该阈值的票（默认 15）。
      </p>
      <div class="band-row">
        <span class="band-idx">距年高≤</span>
        <el-input v-model="rangeDraft.distToYearHighMax" placeholder="15" size="mini" style="width: 120px" />
        <span class="unit">%</span>
      </div>
      <p class="tip" style="margin-top: 16px">
        综合分（竞价TOP盘前初筛变体：不计二/三板绝杀，昨竞实换=当日）：勾选后保留 ≥ 该阈值的票（默认 45）。
      </p>
      <div class="band-row">
        <span class="band-idx">综合分≥</span>
        <el-input v-model="rangeDraft.preScreenScoreMin" placeholder="45" size="mini" style="width: 120px" />
      </div>
      <p class="tip" style="margin-top: 16px">
        流通市值：勾选后保留流通市值 ≤ 该阈值的票（亿，默认 70）。
      </p>
      <div class="band-row">
        <span class="band-idx">市值≤</span>
        <el-input v-model="rangeDraft.marketCapMax" placeholder="70" size="mini" style="width: 120px" />
        <span class="unit">亿</span>
      </div>
      <div slot="footer">
        <el-button size="small" @click="resetFilterConfig">恢复默认</el-button>
        <el-button size="small" @click="filterConfigVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="saveFilterConfig">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="记录库"
      custom-class="hfb-record-library-dialog"
      :visible.sync="recordLibraryVisible"
      width="95%"
      top="4vh"
      append-to-body
      @open="onRecordLibraryDialogOpen"
    >
      <el-tabs v-model="recordLibraryTab">
        <el-tab-pane label="龙头库" name="dragon">
          <RecordLibraryTable
            ref="recordLibraryTable"
            :rows="recordLibraryList"
            :loading="recordLibraryLoading"
            editable
            :editing-id="recordLibraryEditingId"
            :initial-score-version="recordLibraryScoreVersion"
            :max-height="520"
            empty-text="暂无记录，可在本页勾选入库，或在复盘笔记天梯右键入库存"
            @score-version-change="onRecordLibraryScoreVersionChange"
            @start-edit="startRecordLibraryEdit"
            @save-edit="saveRecordLibraryEdit"
            @remove="removeRecordLibraryItem"
          />
        </el-tab-pane>
        <el-tab-pane label="补涨库" name="gapup">
          <GapUpRecordLibraryTable
            :rows="gapUpLibraryList"
            :loading="gapUpLibraryLoading"
            :max-height="520"
            @changed="loadGapUpLibrary"
          />
        </el-tab-pane>
      </el-tabs>
      <span slot="footer">
        <el-button @click="recordLibraryVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { stockApi } from '@/api/stockApi'
import RecordLibraryTable from '@/components/RecordLibraryTable.vue'
import GapUpRecordLibraryTable from '@/components/GapUpRecordLibraryTable.vue'
import {
  RANGE_FIELDS,
  loadRangeConfig,
  cloneRangeConfig,
  defaultRangeConfig,
  saveRangeConfig,
  cutpointsToOptions,
  parsePct,
  applyHfbStyleFilters,
  formatSlopeX1000Pct
} from '@/utils/hfbChipFilters'

function withChipScoreSum(rows) {
  return (Array.isArray(rows) ? rows : []).map((r) => {
    const s = Number(r.shortChip)
    const m = Number(r.midChip)
    const l = Number(r.longChip)
    const ok = Number.isFinite(s) && Number.isFinite(m) && Number.isFinite(l)
    let gapChipSum = Number(r.gapChipSum)
    if (!Number.isFinite(gapChipSum)) {
      gapChipSum = Number.isFinite(m) && Number.isFinite(l) ? m + l : null
    }
    return {
      ...r,
      chipScoreSum: ok ? s + m + l : null,
      gapChipSum
    }
  })
}

/** 按当日查询结果分别排名（降序）；缺失不参与该维 */
function withDayRanks(rows) {
  const list = Array.isArray(rows) ? rows : []
  const ranks = new Map()
  const ensure = (row) => {
    const key = `${row.code || ''}|${row.firstBoardDate || ''}`
    if (!ranks.has(key)) ranks.set(key, {})
    return ranks.get(key)
  }
  // asc=越小越靠前（T/B）；desc=越大越靠前（J）
  const assign = (getter, field, dir = 'desc') => {
    const scored = list
      .map((r, i) => ({ r, v: Number(getter(r)), i }))
      .filter((x) => Number.isFinite(x.v))
      .sort((a, b) => {
        if (a.v !== b.v) return dir === 'asc' ? a.v - b.v : b.v - a.v
        return a.i - b.i
      })
    scored.forEach((x, idx) => {
      ensure(x.r)[field] = idx + 1
    })
  }
  assign((r) => r.chipScoreSum, 'rankT', 'asc')
  assign((r) => r.gapChipSum, 'rankB', 'asc')
  assign((r) => r.auctionKillScore2b, 'rankJ2', 'desc')
  assign((r) => r.auctionKillScore3b, 'rankJ3', 'desc')
  return list.map((r) => {
    const rk = ranks.get(`${r.code || ''}|${r.firstBoardDate || ''}`) || {}
    return {
      ...r,
      rankT: rk.rankT || null,
      rankB: rk.rankB || null,
      rankJ2: rk.rankJ2 || null,
      rankJ3: rk.rankJ3 || null
    }
  })
}

export default {
  name: 'HistoryFirstBoard',
  components: { RecordLibraryTable, GapUpRecordLibraryTable },
  data() {
    const rangeConfig = loadRangeConfig()
    return {
      tradeDate: '',
      loading: false,
      rows: [],
      page: 1,
      pageSize: 100,
      filterBaoVol: false,
      filterTouchBoard: false,
      filterSlope: false,
      filterMarketCap70: false,
      filterMa250: false,
      filterAboveAllMa: false,
      filterDistToYearHigh: false,
      filterPreScreenScore: false,
      filterShortChipBands: [],
      filterMidChipBands: [],
      filterLongChipBands: [],
      rangeFields: RANGE_FIELDS,
      rangeConfig,
      rangeDraft: cloneRangeConfig(rangeConfig),
      filterConfigVisible: false,
      libraryKeySet: {},
      recordLibraryVisible: false,
      recordLibraryTab: 'dragon',
      recordLibraryLoading: false,
      recordLibraryList: [],
      recordLibraryEditingId: '',
      recordLibraryScoreVersion: 'V5',
      gapUpLibraryList: [],
      gapUpLibraryLoading: false,
      nextDayLoading: false
    }
  },
  mounted() {
    this.refreshLibraryKeys()
  },
  computed: {
    slopeMinDisplay() {
      const n = Number(this.rangeConfig.slopeMin)
      return Number.isFinite(n) ? String(n) : '10'
    },
    slopeMinValue() {
      const n = Number(this.rangeConfig.slopeMin)
      return Number.isFinite(n) ? n : 10
    },
    distToYearHighMaxDisplay() {
      const n = Number(this.rangeConfig.distToYearHighMax)
      return Number.isFinite(n) ? String(n) : '15'
    },
    distToYearHighMaxValue() {
      const n = Number(this.rangeConfig.distToYearHighMax)
      return Number.isFinite(n) ? n : 15
    },
    marketCapMaxDisplay() {
      const n = Number(this.rangeConfig.marketCapMax)
      return Number.isFinite(n) ? n : 70
    },
    marketCapMaxValue() {
      return this.marketCapMaxDisplay
    },
    preScreenScoreMinDisplay() {
      const n = Number(this.rangeConfig.preScreenScoreMin)
      return Number.isFinite(n) ? String(n) : '45'
    },
    preScreenScoreMinValue() {
      const n = Number(this.rangeConfig.preScreenScoreMin)
      return Number.isFinite(n) ? n : 45
    },
    shortChipOptions() {
      return cutpointsToOptions(this.rangeConfig.short)
    },
    midChipOptions() {
      return cutpointsToOptions(this.rangeConfig.mid)
    },
    longChipOptions() {
      return cutpointsToOptions(this.rangeConfig.long)
    },
    filteredRows() {
      const list = applyHfbStyleFilters(this.rows, {
        filterBaoVol: this.filterBaoVol,
        filterTouchBoard: this.filterTouchBoard,
        filterSlope: this.filterSlope,
        filterMarketCap70: this.filterMarketCap70,
        marketCapMaxValue: this.marketCapMaxValue,
        filterMa250: this.filterMa250,
        filterAboveAllMa: this.filterAboveAllMa,
        filterDistToYearHigh: this.filterDistToYearHigh,
        distToYearHighMaxValue: this.distToYearHighMaxValue,
        filterPreScreenScore: this.filterPreScreenScore,
        preScreenScoreMinValue: this.preScreenScoreMinValue,
        filterShortChipBands: this.filterShortChipBands,
        filterMidChipBands: this.filterMidChipBands,
        filterLongChipBands: this.filterLongChipBands,
        shortChipOptions: this.shortChipOptions,
        midChipOptions: this.midChipOptions,
        longChipOptions: this.longChipOptions,
        slopeMinValue: this.slopeMinValue
      })
      // 默认按最终连板高度降序（跨分页一致）
      return [...list].sort((a, b) => {
        const av = Number(a.finalBoards)
        const bv = Number(b.finalBoards)
        const aOk = Number.isFinite(av)
        const bOk = Number.isFinite(bv)
        if (aOk && bOk && av !== bv) return bv - av
        if (aOk !== bOk) return aOk ? -1 : 1
        return String(a.code || '').localeCompare(String(b.code || ''))
      })
    },
    pagedRows() {
      const start = (this.page - 1) * this.pageSize
      return this.filteredRows.slice(start, start + this.pageSize)
    }
  },
  watch: {
    filteredRows() {
      const maxPage = Math.max(1, Math.ceil(this.filteredRows.length / this.pageSize) || 1)
      if (this.page > maxPage) this.page = maxPage
    },
    filterBaoVol() {
      this.page = 1
    },
    filterTouchBoard() {
      this.page = 1
    },
    filterSlope() {
      this.page = 1
    },
    filterMarketCap70() {
      this.page = 1
    },
    filterMa250() {
      this.page = 1
    },
    filterAboveAllMa() {
      this.page = 1
    },
    filterDistToYearHigh() {
      this.page = 1
    },
    filterPreScreenScore() {
      this.page = 1
    },
    filterShortChipBands() {
      this.page = 1
    },
    filterMidChipBands() {
      this.page = 1
    },
    filterLongChipBands() {
      this.page = 1
    },
    rangeConfig: {
      deep: true,
      handler() {
        this.page = 1
        const shortOk = new Set(this.shortChipOptions.map((o) => o.value))
        const midOk = new Set(this.midChipOptions.map((o) => o.value))
        const longOk = new Set(this.longChipOptions.map((o) => o.value))
        this.filterShortChipBands = this.filterShortChipBands.filter((v) => shortOk.has(v))
        this.filterMidChipBands = this.filterMidChipBands.filter((v) => midOk.has(v))
        this.filterLongChipBands = this.filterLongChipBands.filter((v) => longOk.has(v))
      }
    }
  },
  methods: {
    libraryRowKey(row) {
      return `${row.code || ''}|${row.firstBoardDate || ''}`
    },
    isInLibrary(row) {
      return !!this.libraryKeySet[this.libraryRowKey(row)]
    },
    async refreshLibraryKeys() {
      try {
        const res = await stockApi.fetchRecordLibrary()
        const map = {}
        const list = Array.isArray(res?.data) ? res.data : []
        list.forEach((r) => {
          if (!r?.code || !r?.firstBoardDate) return
          map[`${r.code}|${r.firstBoardDate}`] = r.id
        })
        this.libraryKeySet = map
      } catch (_) {
        /* ignore */
      }
    },
    openRecordLibrary() {
      this.recordLibraryVisible = true
    },
    onRecordLibraryDialogOpen() {
      this.loadRecordLibrary()
      this.loadGapUpLibrary()
    },
    async loadGapUpLibrary() {
      this.gapUpLibraryLoading = true
      try {
        const res = await stockApi.fetchGapUpLibrary()
        this.gapUpLibraryList = Array.isArray(res?.data) ? res.data : []
      } catch (e) {
        this.gapUpLibraryList = []
        this.$message.error(e?.message || '加载补涨库失败')
      } finally {
        this.gapUpLibraryLoading = false
      }
    },
    onRecordLibraryScoreVersionChange(version) {
      this.recordLibraryScoreVersion =
        version === 'V1' || version === 'V2' || version === 'V3' || version === 'V4' || version === 'V5'
          ? version
          : 'V5'
      this.loadRecordLibrary()
    },
    async loadRecordLibrary() {
      this.recordLibraryLoading = true
      this.recordLibraryEditingId = ''
      try {
        const res = await stockApi.fetchRecordLibrary({
          scoreVersion: this.recordLibraryScoreVersion
        })
        this.recordLibraryList = Array.isArray(res?.data) ? res.data : []
        const map = {}
        this.recordLibraryList.forEach((r) => {
          if (!r?.code || !r?.firstBoardDate) return
          map[`${r.code}|${r.firstBoardDate}`] = r.id
        })
        this.libraryKeySet = map
      } catch (e) {
        this.recordLibraryList = []
        this.$message.error(e?.message || '加载记录库失败')
      } finally {
        this.recordLibraryLoading = false
      }
    },
    startRecordLibraryEdit(row) {
      if (!row?.id) return
      this.recordLibraryList.forEach((item) => {
        if (item.id !== row.id) {
          this.$set(item, '_editFinalBoards', '')
          this.$set(item, '_editType', '')
        }
      })
      this.$set(row, '_editFinalBoards', row.finalBoards != null ? String(row.finalBoards) : '1')
      this.$set(row, '_editType', row.type || '')
      this.recordLibraryEditingId = row.id
    },
    async saveRecordLibraryEdit(row) {
      if (!row?.id || this.recordLibraryEditingId !== row.id) return
      const n = Number(row._editFinalBoards)
      if (!Number.isFinite(n) || n < 1) {
        this.$message.warning('最终连板高度须为 >=1 的数字')
        return
      }
      const type = String(row._editType || '').trim()
      if (type && type !== '龙头' && type !== '补涨') {
        this.$message.warning('类型仅支持：龙头 / 补涨')
        return
      }
      this.$set(row, '_saving', true)
      try {
        const res = await stockApi.updateRecordLibrary(row.id, {
          finalBoards: Math.floor(n),
          type
        })
        if (!res?.ok) {
          this.$message.error(res?.message || '保存失败')
          return
        }
        Object.assign(row, res.data || {})
        row._editFinalBoards = ''
        row._editType = ''
        this.recordLibraryEditingId = ''
        this.$message.success('已保存')
      } catch (e) {
        this.$message.error(e?.message || '保存失败')
      } finally {
        this.$set(row, '_saving', false)
      }
    },
    async removeRecordLibraryItem(row) {
      if (!row?.id) return
      try {
        await this.$confirm(`确认从记录库删除 ${row.name || row.code}？`, '提示', {
          type: 'warning'
        })
      } catch (_) {
        return
      }
      try {
        const res = await stockApi.deleteRecordLibrary(row.id)
        if (!res?.ok) {
          this.$message.error(res?.message || '删除失败')
          return
        }
        this.recordLibraryList = this.recordLibraryList.filter((item) => item.id !== row.id)
        if (this.recordLibraryEditingId === row.id) this.recordLibraryEditingId = ''
        const map = { ...this.libraryKeySet }
        delete map[this.libraryRowKey(row)]
        this.libraryKeySet = map
        this.$message.success('已删除')
      } catch (e) {
        this.$message.error(e?.message || '删除失败')
      }
    },
    async onToggleLibrary(row, checked) {
      if (!row?.code || !row?.firstBoardDate) return
      this.$set(row, '_libBusy', true)
      try {
        if (checked) {
          const res = await stockApi.addRecordLibrary({
            source: 'history-first-board',
            code: row.code,
            name: row.name || '',
            firstBoardDate: row.firstBoardDate,
            finalBoards: row.finalBoards,
            firstBoardPrice: row.firstBoardPrice,
            ma250: row.ma250,
            freeFloatMarketCap: row.freeFloatMarketCap,
            bao2: row.bao2,
            bao3: row.bao3,
            touchBoardNext: row.touchBoardNext,
            aboveAllMa: row.aboveAllMa,
            yearHighNear1y: row.yearHighNear1y,
            distToYearHighPct: row.distToYearHighPct,
            shortChip: row.shortChip,
            midChip: row.midChip,
            longChip: row.longChip,
            gapChipSum: row.gapChipSum,
            fullChip: row.fullChip,
            chipSlope: row.chipSlope,
            rangeAllD0: row.rangeAllD0,
            chipV2Score: row.chipV2Score,
            priceToMax: row.priceToMax,
            pricePositionLevel: row.pricePositionLevel,
            pricePositionLabel: row.pricePositionLabel,
            chipV2ThresholdVersion: row.chipV2ThresholdVersion,
            mainNetInflow0: row.mainNetInflow0,
            mainNetInflow1: row.mainNetInflow1,
            mainNetInflow2: row.mainNetInflow2,
            netInflowToAmount0: row.netInflowToAmount0,
            netInflowToAmount1: row.netInflowToAmount1,
            netInflowToAmount2: row.netInflowToAmount2,
            auctionGain2b: row.auctionGain2b,
            auctionTurnover2b: row.auctionTurnover2b,
            auctionVolumeRatio2b: row.auctionVolumeRatio2b,
            auctionKillScore2b: row.auctionKillScore2b,
            auctionGain3b: row.auctionGain3b,
            auctionTurnover3b: row.auctionTurnover3b,
            auctionVolumeRatio3b: row.auctionVolumeRatio3b,
            auctionKillScore3b: row.auctionKillScore3b
          })
          const id = res?.data?.id || res?.id
          if (res?.ok && id) {
            this.$set(this.libraryKeySet, this.libraryRowKey(row), id)
            this.$message.success(`已入记录库：${row.name || row.code}`)
          } else if (res?.id || id) {
            // 409 已存在
            this.$set(this.libraryKeySet, this.libraryRowKey(row), res.id || id)
            this.$message.warning(res?.message || '已在记录库')
          } else {
            this.$message.error(res?.message || '入记录库失败')
          }
        } else {
          const id = this.libraryKeySet[this.libraryRowKey(row)]
          if (!id) return
          try {
            await this.$confirm(`确认从记录库移除 ${row.name || row.code}？`, '提示', {
              type: 'warning'
            })
          } catch (_) {
            return
          }
          const res = await stockApi.deleteRecordLibrary(id)
          if (!res?.ok) {
            this.$message.error(res?.message || '移除失败')
            return
          }
          const map = { ...this.libraryKeySet }
          delete map[this.libraryRowKey(row)]
          this.libraryKeySet = map
          this.recordLibraryList = this.recordLibraryList.filter((item) => item.id !== id)
          this.$message.success('已从记录库移除')
        }
      } catch (e) {
        const msg = e?.message || e?.data?.message || ''
        const id = e?.data?.id || e?.id
        if (id && checked) {
          this.$set(this.libraryKeySet, this.libraryRowKey(row), id)
          this.$message.warning(msg || '已在记录库')
        } else {
          this.$message.error(msg || (checked ? '入记录库失败' : '移除失败'))
        }
      } finally {
        this.$set(row, '_libBusy', false)
      }
    },
    openFilterConfig() {
      this.rangeDraft = cloneRangeConfig(this.rangeConfig)
      this.filterConfigVisible = true
    },
    resetFilterConfig() {
      this.rangeDraft = defaultRangeConfig()
    },
    saveFilterConfig() {
      const next = cloneRangeConfig(this.rangeDraft)
      for (const f of RANGE_FIELDS) {
        const aPct = parsePct(next[f.key].a)
        const bPct = parsePct(next[f.key].b)
        const cPct = parsePct(next[f.key].c)
        if (aPct == null || bPct == null || cPct == null) {
          this.$message.warning(`${f.label}请填写三个分界值`)
          return
        }
        if (!(aPct < bPct && bPct < cPct)) {
          this.$message.warning(`${f.label}须满足 a < b < c`)
          return
        }
      }
      const slopeMin = Number(next.slopeMin)
      if (!Number.isFinite(slopeMin)) {
        this.$message.warning('分段斜率阈值须为数字')
        return
      }
      const distMax = Number(next.distToYearHighMax)
      if (!Number.isFinite(distMax)) {
        this.$message.warning('距年高阈值须为数字')
        return
      }
      const preMin = Number(next.preScreenScoreMin)
      if (!Number.isFinite(preMin)) {
        this.$message.warning('综合分阈值须为数字')
        return
      }
      const capMax = Number(next.marketCapMax)
      if (!Number.isFinite(capMax) || capMax <= 0) {
        this.$message.warning('流通市值上限须为正数')
        return
      }
      next.slopeMin = String(slopeMin)
      next.slopeUnit = 'x1000pct'
      next.distToYearHighMax = String(distMax)
      next.preScreenScoreMin = String(preMin)
      next.marketCapMax = String(capMax)
      this.rangeConfig = next
      saveRangeConfig(next)
      this.filterConfigVisible = false
      this.$message.success('过滤配置已保存')
    },
    fmtNum(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return Number(n.toFixed(2))
    },
    fmtPreScreenScore(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return n.toFixed(1)
    },
    fmtBaoVol(row) {
      const isBao2 = row && row.bao2 === true
      const isBao3 = row && row.bao3 === true
      if (isBao2 && isBao3) return '爆2|爆3'
      if (isBao2) return '爆2'
      if (isBao3) return '爆3'
      return '缩量'
    },
    fmtBool(_r, _c, v) {
      if (v === true) return '是'
      if (v === false) return '否'
      return '-'
    },
    fmtChipPct(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return `${(n * 100).toFixed(2)}%`
    },
    fmtChipV2Score(row) {
      const s = Number(row?.chipV2Score)
      if (!Number.isFinite(s)) return '-'
      const tag = s >= 90 ? '强' : s >= 70 ? '中' : '弱'
      return `${s}｜${tag}`
    },
    fmtRangeAllD0(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return `${(n * 100).toFixed(1)}%`
    },
    fmtPriceToMax(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      const sign = n > 0 ? '+' : ''
      return `${sign}${(n * 100).toFixed(1)}%`
    },
    fmtSlope(_r, _c, v) {
      return formatSlopeX1000Pct(v)
    },
    fmtDistYearHigh(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return `${n.toFixed(2)}%`
    },
    fmtAuctionNum(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return Number(n.toFixed(2))
    },
    /** 元 → 亿 */
    fmtYi(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return Number((n / 1e8).toFixed(2))
    },
    /** 小数比例 → 百分数 */
    fmtRatioPct(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return `${(n * 100).toFixed(2)}%`
    },
    async handleNextTradeDay() {
      if (!this.tradeDate) {
        this.$message.warning('请选择日期')
        return
      }
      this.nextDayLoading = true
      try {
        const res = await stockApi.nextHistoryFirstBoardTradeDate(this.tradeDate)
        if (!res?.ok || !res.nextTradeDate) {
          this.$message.warning(res?.message || '无下一交易日')
          return
        }
        this.tradeDate = res.nextTradeDate
        await this.handleQuery()
      } catch (e) {
        this.$message.error(e?.message || '获取下一交易日失败')
      } finally {
        this.nextDayLoading = false
      }
    },
    relayoutTable() {
      this.$nextTick(() => {
        if (this.$refs.hfbTable && this.$refs.hfbTable.doLayout) {
          this.$refs.hfbTable.doLayout()
        }
      })
    },
    async handleQuery() {
      if (!this.tradeDate) {
        this.$message.warning('请选择日期')
        return
      }
      this.loading = true
      try {
        const res = await stockApi.queryHistoryFirstBoard({
          startDate: this.tradeDate,
          endDate: this.tradeDate
        })
        this.rows = withDayRanks(withChipScoreSum(res?.data))
        this.page = 1
        await this.refreshLibraryKeys()
        if (!this.rows.length) {
          this.$message.info('该日无首板记录')
        }
        this.relayoutTable()
      } catch (e) {
        this.$message.error(e?.message || '查询失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.history-first-board {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  padding: 12px 16px;
  box-sizing: border-box;
  overflow: hidden;
}
.toolbar {
  margin-bottom: 12px;
  flex-shrink: 0;
  min-width: 0;
}
.toolbar-scroll {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 4px;
  -webkit-overflow-scrolling: touch;
}
.toolbar-scroll ::v-deep .el-checkbox {
  flex-shrink: 0;
  white-space: nowrap;
  margin-right: 0;
}
.filter-chip-label {
  color: #606266;
  font-size: 13px;
  margin-left: 4px;
  flex-shrink: 0;
  white-space: nowrap;
}
.filter-chip-band-select {
  width: 150px;
  flex-shrink: 0;
}
.hint {
  color: #909399;
  font-size: 13px;
  flex-shrink: 0;
  white-space: nowrap;
}
.table-wrap {
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}
.result-table {
  width: 100%;
}
.result-table ::v-deep .el-table__header th .cell {
  white-space: nowrap;
}
.pager {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.tip {
  margin: 0 0 12px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
.band-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.band-idx {
  width: 52px;
  color: #606266;
  font-size: 13px;
}
.band-sep {
  color: #909399;
}
.unit {
  color: #909399;
  font-size: 12px;
}
.rank-tags {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}
.chip-v2-overextended {
  color: #e6a23c;
  font-weight: 600;
}
</style>

<style lang="scss">
.hfb-record-library-dialog {
  .el-dialog__body {
    padding-top: 8px;
    overflow-x: auto;
    min-width: 0;
  }
}
</style>
